<template>
  <div>
    <v-row class="d-flex justify-space-between" flat>
      <v-col cols="12" md="4">
        <h1 class="heading-1">Edit Help Topic</h1>
      </v-col>
    </v-row>
    <div class="my-9">
      <v-tabs v-model="tab" slider-color="transparent">
        <div
          class="d-flex"
          style="width: 100%; background: rgba(236, 241, 242, 1)"
        >
          <v-tab
            ripple
            href="#tab-1"
            @click="
              () => {
                this.tab == 'tab-1';
                this.continuebtn = true;
              }
            "
            ><span class="tabs_style text_style"> Content </span></v-tab
          >

          <v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-2"
            @click="
              () => {
                this.tab == 'tab-2';
                this.continuebtn = false;
              }
            "
          >
            <span class="tabs_style text_style"> Publish/Preview </span>
          </v-tab>
        </div>
        <v-tab-item value="tab-1">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <v-text-field
                single-line
                flat
                label="Write you title here"
                height="60"
                hide-details=""
              ></v-text-field>
              <v-select
                class="mt-3"
                single-line
                dense
                flat
                multiple
                label="Category"
                height="60"
                hide-details=""
                :items="categoryitem"
              ></v-select>
              <v-select
                class="mt-3"
                single-line
                dense
                flat
                multiple
                label="Language"
                height="60"
                hide-details=""
                v-model="language"
                :items="languageitem"
              ></v-select>
              <div class="mt-13">
                <blogtextediter-component />
              </div>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <div style="margin: 0 8.9vw">
            <div class="mt-5">
              <h2 class="heading-1"><b>Help topic sample Question?</b></h2>
            </div>
            <div class="mt-8">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id eu
              duis in gravida dignissim vitae. Sit diam sed elementum, tortor
              vestibulum elit diam viverra. Vitae molestie non eget senectus in
              pharetra parturient consectetur. Natoque purus non elit justo,
              integer lectus tortor ullamcorper. Dictum nullam eget ac cras
              lobortis egestas feugiat urna, varius. Lacus erat nisi purus nam.
              Commodo risus augue viverra sapien praesent urna, nisl. Dictumst
              nunc elit libero, fames a mattis porttitor ornare. Vitae gravida
              tempus eget nascetur. Arcu, dolor feugiat consequat, eget.
              Volutpat nibh hendrerit tellus at dolor consectetur. Sed a
              adipiscing placerat ut in et vitae, neque. Nisl et turpis viverra
              ac egestas ultrices. Non nisl sed consequat vulputate fringilla
              sit gravida. Vitae est et velit in pellentesque nisl, in nisl,
              velit. Suspendisse ornare gravida tortor et. Tortor et mattis
              eros, in amet est. Dui velit, ut egestas quis sem. Id egestas
              donec commodo massa quis ut lectus. Arcu eleifend laoreet quis
              habitant viverra pellentesque viverra senectus enim. Vitae turpis
              orci non aenean. Non nisl sed consequat vulputate fringilla sit
              gravida. Vitae est et velit in pellentesque nisl, in nisl, velit.
              Suspendisse ornare gravida tortor et. Tortor et mattis eros, in
              amet est. Dui velit, ut egestas quis sem. Id egestas donec commodo
              massa quis ut lectus. Arcu eleifend laoreet quis habitant viverra
              pellentesque viverra senectus enim. Vitae turpis orci non aenean.
              <br/>
              <br/>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id eu
              duis in gravida dignissim vitae. Sit diam sed elementum, tortor
              vestibulum elit diam viverra. Vitae molestie non eget senectus in
              pharetra parturient consectetur. Natoque purus non elit justo,
              integer lectus tortor ullamcorper. Dictum nullam eget ac cras
              lobortis egestas feugiat urna, varius. Lacus erat nisi purus nam.
              Commodo risus augue viverra sapien praesent urna, nisl. Dictumst
              nunc elit libero, fames a mattis porttitor ornare. Vitae gravida
              tempus eget nascetur. Arcu, dolor feugiat consequat, eget.
              Volutpat nibh hendrerit tellus at dolor consectetur. Sed a
              adipiscing placerat ut in et vitae, neque. Nisl et turpis viverra
              ac egestas ultrices. Non nisl sed consequat vulputate fringilla
              sit gravida. Vitae est et velit in pellentesque nisl, in nisl,
              velit. Suspendisse ornare gravida tortor et. Tortor et mattis
              eros, in amet est.
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
    <v-divider class="my-6"></v-divider>
    <v-card flat class="d-flex justify-end mb-9">
      <v-btn
        outlined
        style="border: thin solid rgba(8, 8, 22, 0.15)"
        class="px-9 py-2 mx-9 text_style"
        >Cancel</v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        @click="changeTab()"
        v-if="continuebtn == true"
        >Continue</v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        v-if="continuebtn == false"
        @click="send()"
      >
        <span v-if="btnloader != true"> Publish now </span>
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import BlogtextediterComponent from "../../components/Courses/NewParamaCouse/blogtextediter.component.vue";
export default {
  components: { BlogtextediterComponent },
  name: "NewCoursesComponent",

  data() {
    return {
      continuebtn: true,
      tab: "tab-1",

      language: [],
      languageitem: [
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
    };
  },
  methods: {
        changeTab() { 
      if (this.tab == "tab-1") {
        this.tab = "tab-2";
      } else{
        this.continuebtn = false;
      }
    },
   
  },
};
</script>

<style scoped>
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
}
.tabs_style {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
}
a:hover {
  text-decoration: none;
}
.v-tabs-slider {
  background-color: white !important;
}
.h1_tab2 {
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}
.content_span {
  font-family: " DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}
.content_date {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.38);
}
.content_chip {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #54be5a;
}
#no-background-hover::before {
  background-color: transparent !important;
}
@media screen and (max-width: 750px) {
  h1 {
    font-size: 23px;
  }
}
@media screen and (max-width: 430px) {
  .v-application .mx-14 {
    margin-right: 20px !important;
    margin-left: 10px !important;
  }
}
</style>